import { useIntl } from 'react-intl';

import useAuth from 'src/hooks/useAuth';

import { formatWeight, hasValue } from '../utils';

function BowTieControlMetadata({ control }) {
  const intl = useIntl();
  const { decimalSeparator, thousandsSeparator } = useAuth();
  const effectiveness = control?.ultimaEfetividade;
  const hasWeight = hasValue(control?.peso);
  const hasEffectiveness = hasValue(effectiveness);

  if (!hasWeight && !hasEffectiveness) return null;

  return (
    <span className="bow-tie__control-metadata">
      {hasWeight && (
        <span className="bow-tie__control-chip">
          {`${intl.formatMessage({ id: 'peso' })}: ${formatWeight(
            control.peso,
            decimalSeparator,
            thousandsSeparator
          )}%`}
        </span>
      )}
      {hasEffectiveness && (
        <span className="bow-tie__control-chip">
          {`${intl.formatMessage({
            id: 'label.efetividade',
          })}: ${effectiveness}`}
        </span>
      )}
    </span>
  );
}

export default BowTieControlMetadata;
